import { CheckoutTranslation, type TranslatedValue } from "@swo/storefront";
import { ClientCartFullBillingAddress } from "@swo/storefront";
import { Translated } from "../../../../../../../domain/translations/translations";
import { tObj } from "../../../../../../../components/T";

export function translatedCtpField(t: Translated<CheckoutTranslation>) {
  return (ctpFieldName: keyof ClientCartFullBillingAddress): TranslatedValue => {
    switch (ctpFieldName) {
      case "firstName": {
        return t("addressForm.firstName");
      }
      case "lastName": {
        return t("addressForm.lastName");
      }
      case "title": {
        return t("addressForm.title");
      }
      case "streetName": {
        return t("addressForm.addressFirstLine");
      }
      case "additionalAddressInfo": {
        return t("addressForm.addressSecondLine");
      }
      case "postalCode": {
        return t("addressForm.postalCode");
      }
      case "city": {
        return t("addressForm.city");
      }
      case "state": {
        return t("addressForm.state");
      }
      case "phone": {
        return t("addressForm.phoneNumber");
      }
      case "email": {
        return t("addressForm.email");
      }
      case "country": {
        return t("addressForm.country");
      }
      default: {
        console.warn(`Untranslated field '${ctpFieldName}'`);
        return tObj.fallbackOf(ctpFieldName);
      }
    }
  };
}
